// eslint-disable-next-line no-shadow
export enum MoveDirection {
  top = 'top',
  up = 'up',
  down = 'down',
  bottom = 'bottom'
}
